import { useContext, useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  Addchart,
  CalendarMonth,
  Equalizer,
  GpsFixedOutlined,
  MarkEmailUnread,
  PictureAsPdf,
  ReportSharp,
  VerifiedUser,
} from "@mui/icons-material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReceiptIcon from "@mui/icons-material/Receipt";
import BiotechIcon from "@mui/icons-material/Biotech";

const Item = ({ title, to, icon, selected, setSelected, setIsCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => {
        setSelected(title);
        // setIsCollapsed(true);
      }}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({ loggedUser, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <Box
      sx={{
        height: "100vh",
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "1px 30px 1px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
        // position: "fixed",
        // zIndex: 100,
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]}>
                  MatLab
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                  src={
                    loggedUser.userGroup.groupName === "User"
                      ? `../../assets/no_User.png`
                      : `../../assets/user.jpg`
                  }
                  // style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {loggedUser.firstName}
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  {}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              setIsCollapsed={setIsCollapsed}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 10px" }}
            >
              Requests
            </Typography>
            {loggedUser?.position.id == 4 ? (
              <Item
                title="New Requests"
                to="/newJobReq"
                // icon={<PeopleOutlinedIcon />}
                icon={<ReceiptOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}
            {loggedUser.position.id == 4 ? (
              <Item
                title="Job Payments"
                to="/payment"
                icon={<AttachMoneyIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}

            {loggedUser.position.id == 4 ? (
              <Item
                title="Job Assigning"
                to="/approveJob"
                icon={<ContactsOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}
            {loggedUser.position.id !== 1 ? (
              <Item
                title="Your Jobs"
                to="/toPanel"
                icon={<ReceiptIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}
            {loggedUser.position.id === 1 ? (
              <Item
                title="Approve Jobs"
                to="/approve"
                icon={<VerifiedUser />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}
            {loggedUser.position.id !== 1 ? (
              <Item
                title="Institues"
                to="/institutes"
                icon={<PeopleOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}
            {loggedUser.position.id === 1 ? (
              <Item
                title="System Users"
                to="/users"
                icon={<PersonOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}

            {loggedUser.position.id === 1 ? (
              <Item
                title="Lab Tests"
                to="/newtest"
                icon={<BiotechIcon />}
                selected={selected}
                setSelected={setSelected}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              ""
            )}

            <Item
              title="Expenses"
              to="/expenses"
              icon={<Addchart />}
              selected={selected}
              setSelected={setSelected}
              setIsCollapsed={setIsCollapsed}
            />
            <Item
              title="All Reports"
              to="/allReports"
              icon={<MarkEmailUnread />}
              selected={selected}
              setSelected={setSelected}
              setIsCollapsed={setIsCollapsed}
            />
            <Item
              title="Reports"
              to="/reports"
              icon={<Equalizer />}
              selected={selected}
              setSelected={setSelected}
              setIsCollapsed={setIsCollapsed}
            />
            <Item
              title="Track Jobs"
              to="/track"
              icon={<GpsFixedOutlined />}
              selected={selected}
              setSelected={setSelected}
              setIsCollapsed={setIsCollapsed}
            />
            {/* <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Jobs
            </Typography>
            <Item
              title="View Requests / Jobs"
              to="/form"
              icon={<PersonOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Job Assign"
              to="/calendar"
              icon={<CalendarTodayOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Job Status"
              to="/faq"
              icon={<HelpOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Seat organize"
              to="/seat"
              icon={<TheaterComedy />}
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 10px" }}
            >
              Reports
            </Typography> */}
            {/* <Item
              title="Concrete Report"
              to="/concrete"
              icon={<ConstructionOutlined />}
              selected={selected}
              setSelected={setSelected}
            /> */}
            {/* <Item
              title="New Request"
              to="/newJobReq"
              icon={<BarChartOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Completed Reports"
              to="/institutes"
              icon={<PieChartOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Users"
              to="/users"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Payments"
              to="/payment"
              icon={<AttachMoneyIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}
            <Item
              title="Job Assign"
              to="/calendar"
              icon={<CalendarMonth />}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
